import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from '../../../../../Label';
import Button from '../../../../../Button';
import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';

const propTypes = {
  className: PropTypes.string,
  onCardElementCreate: PropTypes.func.isRequired,
  zElementIndexMax: PropTypes.number,
};

const CardDesignerBarCodeControls = ({
  className,
  onCardElementCreate,
  zElementIndexMax,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const handleAddBarcode = () => {
    onCardElementCreate({
      cardElementType: CARD_ELEMENT_TYPE.BARCODE,
      cardElementConfiguration: {
        is_editable: false,
      },
      input: {
        frame: {
          x: 0.1,
          y: 0.7,
          width: 0.4,
          height: 0.15,
        },
        z_index: zElementIndexMax,
      },
    });
  };

  return (
    <div className={classes}>
      <Label id="barcode-control">ADD BARCODE</Label>
      <Button btnBlock btnStyle="primary" onClick={handleAddBarcode}>
        Add a barcode
      </Button>
      <p className="text-light text-center text-xs mt-2">
        NOTE: The final barcode will be generated automatically when the ID card
        is created.
      </p>
    </div>
  );
};

CardDesignerBarCodeControls.propTypes = propTypes;

export default CardDesignerBarCodeControls;
